import React from "react";

interface ListItem {
    label: string | React.ReactNode;
    description: string | React.ReactNode;
    classNames?: {
        label?: string;
        description?: string;
    };
}

interface ListLabelDescriptionProps {
    list: ListItem[];
    classNames?: {
        labels?: string;
        descriptions?: string;
        container?: string;
    };
    className?: string;
}

const ListLabelDescription: React.FC<ListLabelDescriptionProps> = ({ list, classNames = {}, className="" }) => {
    return (
        <div className={`flex flex-row gap-xl text-text-md ${classNames?.container || ""} ${className}`}>
            <div className={` flex flex-col ${classNames.labels || ""}`}>
                {list.map((item, index) => (
                    <span key={`label-${index}`} className={` ${item.classNames?.label || ""}`}>
                        {item.label}
                    </span>
                ))}
            </div>
            <div className={` flex flex-col ${classNames.descriptions || ""}`}>
                {list.map((item, index) => (
                    <span key={`value-${index}`} className={` ${item.classNames?.description || ""}`}>
                        {item.description}
                    </span>
                ))}
            </div>
        </div>
    );
};

export default ListLabelDescription;
